import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@next/core-lib/i18n';
import { catchError, of, startWith, switchMap } from 'rxjs';

import { LayerBackendService } from '../../../shared/services/layer-backend.service';
import { FeedBalanceService } from '../../services/feed-balance.service';

@Component({
  selector: 'app-feed-balance-action',
  imports: [DatePipe, RouterLink, MatButtonModule, MatIconModule, MatMenuModule, TranslatePipe],
  template: `
    @if (supported) {
      @if (mobile()) {
        <button mat-menu-item [routerLink]="['/flock/feed-balance', flockId()]">
          <mat-icon>dashboard</mat-icon>{{ 'feed-balance.title' | translate }}
          @if (status(); as status) {
            ·
            {{
              (status.savedAt ? 'feed-balance.saved' : 'feed-balance.not-registered') | translate
            }}
          }
        </button>
      } @else {
        <div class="margin-right">
          <button
            mat-flat-button
            [routerLink]="['/flock/feed-balance', flockId()]"
            data-test="feed-balance-open"
          >
            <mat-icon>dashboard</mat-icon>{{ 'feed-balance.title' | translate }}
          </button>
          @if (status(); as status) {
            <small style="display:block" data-test="feed-balance-status">
              {{
                (status.savedAt ? 'feed-balance.saved' : 'feed-balance.not-registered') | translate
              }}
              @if (status.savedAt) {
                · {{ status.savedAt | date: 'short' }}
              }
            </small>
          }
        </div>
      }
    }
  `,
})
export class FeedBalanceActionComponent {
  readonly flockId = input.required<number>();
  readonly mobile = input(false);
  readonly supported = inject(LayerBackendService).isPoultryEnabled;
  private readonly service = inject(FeedBalanceService);
  private readonly selectedId = computed(() => this.flockId());
  readonly status = toSignal(
    toObservable(this.selectedId).pipe(
      switchMap((id) =>
        this.supported
          ? this.service.status(id).pipe(
              catchError(() => of(null)),
              startWith(null),
            )
          : of(null),
      ),
    ),
  );
}
